<app-environment-banner />
<router-outlet></router-outlet>
<p-toast></p-toast>